// @flow

import React from 'react';

type Props = {
  children: React$Node,
  fallback?: React$Node,
};

type State = { hasError: boolean };

class PillErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err: Error) {
    // eslint-disable-next-line no-console
    console.error('PillErrorBoundary caught error:', err);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback === undefined ? null : this.props.fallback;
    }
    return this.props.children;
  }
}

export default PillErrorBoundary;
